import { Component, Input } from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';
import { CardSize } from '@freelancer/ui/card';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, FontType, FontWeight, TextSize } from '@freelancer/ui/text';
import { ContextTypeApi } from 'api-typings/messages/messages_types';
import * as Rx from 'rxjs';
import { AwardProjectModel } from '../user-profile-award-project.types';

@Component({
  selector: 'app-user-profile-award-project-banner',
  template: `
    <fl-card
      [size]="CardSize.SMALL"
      *ngIf="awardProjectBid$ | flAsync as awardProjectModel"
    >
      <fl-bit class="BannerContainer">
        <fl-bit class="BannerContainer-text">
          <fl-text
            [size]="TextSize.SMALL"
            [weight]="FontWeight.BOLD"
            i18n="Placed a bid on project label"
          >
            {{ awardProjectModel.freelancerDisplayName }}
            has placed a bid on your project
            <fl-link
              flTrackingLabel="AwardBannerProjectLink"
              [size]="TextSize.INHERIT"
              [link]="awardProjectModel.projectLink"
            >
              {{ awardProjectModel.projectName }}
            </fl-link>
          </fl-text>
          <fl-text
            [size]="TextSize.SMALL"
            [color]="FontColor.MID"
            [maxLines]="2"
          >
            "{{ awardProjectModel.bidDesc }}"
          </fl-text>
        </fl-bit>

        <fl-bit
          *ngIf="(isDeloitteUserProfile$ | flAsync) === false"
          class="BannerContainer-details"
        >
          <fl-text [size]="TextSize.SMALL" [weight]="FontWeight.BOLD">
            {{
              awardProjectModel.bidAmount
                | flCurrency: awardProjectModel.currency.code
            }}

            <fl-text
              *ngIf="awardProjectModel.hourly"
              i18n="Hourly project bid amount label"
              [fontType]="FontType.SPAN"
              [size]="TextSize.INHERIT"
              [weight]="FontWeight.BOLD"
            >
              /hr
            </fl-text>
          </fl-text>

          <fl-text
            *ngIf="awardProjectModel.hourly; else fixedProject"
            i18n="Hourly project bid duration"
          >
            <fl-text [weight]="FontWeight.BOLD" [fontType]="FontType.SPAN">
              Hours:
            </fl-text>
            <fl-text [fontType]="FontType.SPAN">
              {{ awardProjectModel.duration }} /
              {{ awardProjectModel?.commitment?.interval }}
            </fl-text>
          </fl-text>

          <ng-template #fixedProject>
            <fl-text i18n="Fixed project bid duration">
              in {{ awardProjectModel.duration }} day(s)
            </fl-text>
          </ng-template>
        </fl-bit>

        <fl-bit class="BannerContainer-buttons">
          <fl-button
            i18n="Award button"
            flTrackingLabel="AwardMeBannerAwardButton"
            [busy]="awardMeBusy"
            [color]="ButtonColor.SUCCESS"
            [flMarginRight]="Margin.XXSMALL"
            [fragment]="'proposals'"
            [link]="awardProjectModel.projectLink"
            [queryParams]="{ awardBid: awardProjectModel.bidId }"
            (click)="handleAwardMeClicked()"
          >
            Award
          </fl-button>
          <fl-chat-button
            flTrackingLabel="AwardMeBannerChatButton"
            [otherMemberIds]="[awardProjectModel.freelancerId]"
            [contextType]="ContextTypeApi.PROJECT"
            [contextId]="awardProjectModel.projectId"
          ></fl-chat-button>
        </fl-bit>
      </fl-bit>
    </fl-card>
  `,
  styleUrls: ['./user-profile-award-project-banner.component.scss'],
})
export class UserProfileAwardProjectBannerComponent {
  ButtonColor = ButtonColor;
  CardSize = CardSize;
  FontColor = FontColor;
  TextSize = TextSize;
  FontType = FontType;
  FontWeight = FontWeight;
  Margin = Margin;
  ContextTypeApi = ContextTypeApi;

  @Input() awardProjectBid$: Rx.Observable<AwardProjectModel>;
  @Input() isDeloitteUserProfile$: Rx.Observable<boolean>;

  awardMeBusy = false;

  handleAwardMeClicked(): void {
    this.awardMeBusy = true;
  }
}
